import React, { useState, useEffect } from 'react'



function ErrorNoAdminPage() {


    return (<div>
        <h1 style={{color: 'white'}}>You should not be here</h1>
    </div>)
}


export default ErrorNoAdminPage;
